import { env } from '../env/env';
const ODS_API_URL = env.getString('ODS_API_URL') || 'http://localhost:8000/public-api';
export const odsApiConfig = {
    COMMUNICATION_PREFERENCES_URL: `${ODS_API_URL}/communication-preferences/`,
    COMMUNICATION_CHANNELS_URL: `${ODS_API_URL}/communication-channels/`,
};
//# sourceMappingURL=odsApiConfig.js.map